import React from "react";
import { Typography, WithStyles } from "@material-ui/core";
import { SignInOrRegisterView } from "../../views/SignInOrRegisterView";
import { styles } from "./LogoutTimerView.styles";
import { withStyles } from "@material-ui/styles";
import { CenteredContainer } from "../CenteredContainer/CenteredContainer";

export interface ILogoutTimerViewProps extends WithStyles<typeof styles> {}

export const LogoutTimerViewPure: React.FunctionComponent<ILogoutTimerViewProps> = ({ classes }: ILogoutTimerViewProps) => {

    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography className={classes.topMargin} variant="h2">Logout</Typography>
            </div>
            <Typography variant="h3">You have been logged out due to your inactivity.</Typography>
            <SignInOrRegisterView />
        </CenteredContainer>
    );
};

export const LogoutTimerView = withStyles(styles)(LogoutTimerViewPure);